module.exports = __webpack_public_path__ + "static/media/ic-drawer-mission-control.73931a0e.svg";